import styled from 'styled-components';
import {device} from 'styled/device';

export const CaseBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;

  .paragraph {
    border-bottom: 1px solid #e6e8ec;
    padding: 50px 0 50px 0;
  }

  @media (max-width: ${device.mobileM}) {
    flex-direction: column;

    .paragraph {
      padding: 30px 0 30px 0;

      &:nth-last-child(1) {
        border-bottom: 0;
      }
    }
  }
`;

export const CaseRecommendations = styled.div`
  display: flex;
  flex-direction: column;
  padding: 100px 0;
  margin-top: 50px;

  @media (max-width: ${device.mobileM}) {
    /* display: none; */
  }
`;

export const Image = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 25px;
  height: 570px;
  width: 100%;

  @media (max-width: ${device.mobileM}) {
    border-radius: 20px;
    height: 330px;
  }
`;

export const OrderForm = styled.div`
  background-color: #fcfcfd;
  border: 1px solid #e6e8ec;
  border-radius: 24px;
  color: #23262f;
  padding: 30px 30px 50px 30px;

  .moreDates {
    display: flex;
    justify-content: center;
    color: #23262f;
    font-weight: 500;
    font-size: 16px;
    padding: 40px 0;
  }

  @media (max-width: ${device.mobileM}) {
    padding: 40px 24px 80px 24px;
    box-shadow: 0px 64px 64px #0f0f0f14;

    .moreDates {
      font-weight: 500;
      font-size: 18px;
      padding: 40px 0;
    }
  }
`;

export const Price = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .oldprice {
    color: #b1b5c3;
    font-weight: 400;
    font-size: 32px;
    text-decoration: line-through;
    letter-spacing: -0.32px;
    display: flex;
    align-items: center;
  }

  .newprice {
    color: #23262f;
    font-weight: 700;
    font-size: 32px;
    letter-spacing: -0.32px;
    display: flex;
    align-items: center;
  }

  .textPrice {
    color: #b1b5c4;
    font-weight: 400;
    font-size: 16px;
  }

  @media (max-width: ${device.mobileM}) {
    .oldprice,
    .newprice {
      font-size: 36px;
    }

    .textPrice {
      font-size: 18px;
      white-space: nowrap;
    }
  }
`;

export const PriceButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 13px 0;
  gap: 50px;

  @media (max-width: ${device.mobileM}) {
    gap: 10px;
    flex-direction: column;
    padding: 20px 0 0 0;
  }
`;

export const RoundBadges = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  font-size: 16px;
  color: #777e90;

  @media (max-width: ${device.mobileM}) {
    display: flex;
    flex-direction: column;
    font-size: 18px;
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;

  .scheduleDate {
    color: #23262f;
    font-weight: 500;
    font-size: 16px;
  }

  .scheduleTime {
    color: #777e90;
    font-weight: 400;
    font-size: 12px;
  }

  .subTitle {
    color: #23262f;
    font-weight: 500;
    font-size: 32px;
    padding-bottom: 30px;
  }

  .text18 {
    color: #777e91;
    font-weight: 400;
    font-size: 18px;
    display: flex;
  }

  @media (max-width: ${device.mobileM}) {
    .subTitle {
      font-size: 24px;
    }

    .scheduleDate {
      font-size: 18px;
    }

    .scheduleTime {
      font-size: 14px;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const ExperienceProperty = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
